import React from 'react';
import { columnDefinition, documentDefinition } from '../../../types/Search';

import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
    columnName: string;
    sorted: boolean;
    sortDirection: string;
    handleClick: Function;
}

const SearchResultsColumnHeader: React.FC<Props> = (props) => {
    const sortIcon =
        props.sortDirection == 'asc' ? (
            <FontAwesomeIcon className='sort-icon' icon={faSortUp} size='xs' />
        ) : (
            <FontAwesomeIcon className='sort-icon' icon={faSortDown} size='xs' />
        );

    const onClick = () => {
        props.handleClick(props.columnName);
    };

    return (
        <th scope='col'>
            <span
                style={{
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                }}
                onClick={onClick}
            >
                {props.columnName}
                {props.sorted && sortIcon}
            </span>
        </th>
    );
};

export default SearchResultsColumnHeader;
